import React from "react";
import "../App.css";
import { useState } from "react";
import { useLocation} from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import MultiplicationView from "./MultiplicationView";


const MixColumnsView = () => {

    const navigate = useNavigate();
    const location = useLocation();
    
    const allEncResults = location.state.allEncResults;
    const shiftedRows = location.state.currState;
    const mixColAns = location.state.currMixCols
    
    const previous = () => {
        navigate("/Round", {
            state: { allEncResults },
          });
    }

    const [step, setStep] = useState(0);

    const [mixColAnsHighlateIndex, setMixColAnsHighlateIndex] = useState(0);

    const [rowCount , setRowCount] = useState(0);

    const incrementStep = () => {
        
        if(mixColAnsHighlateIndex < 15){
            if(step == 3){
              setStep(0)
            }
            else{
              setStep(step+1)
            }
            setMixColAnsHighlateIndex(mixColAnsHighlateIndex+1)
        }
        if(mixColAnsHighlateIndex+1 < 4){
            setRowCount(0)
        }
        else if(mixColAnsHighlateIndex+1 < 8  &&  mixColAnsHighlateIndex+1 > 3){
            setRowCount(1)
        }
        else if(mixColAnsHighlateIndex+1 < 12  &&  mixColAnsHighlateIndex+1 > 7){
            setRowCount(2)
        }
        else{
            setRowCount(3)
        }
    }

    const decrementStep = () => {
        
        if(mixColAnsHighlateIndex > 0){
            if(step == 0){
              setStep(3)
            }
            else{
              setStep(step-1)
            }
            setMixColAnsHighlateIndex(mixColAnsHighlateIndex-1)
        }
        if(mixColAnsHighlateIndex-1 < 4){
            setRowCount(0)
        }
        else if(mixColAnsHighlateIndex-1 < 8  &&  mixColAnsHighlateIndex-1 > 3){
            setRowCount(1)
        }
        else if(mixColAnsHighlateIndex-1 < 12  &&  mixColAnsHighlateIndex-1 > 7){
            setRowCount(2)
        }
        else{
            setRowCount(3)
        }
    }

    const [isOpen, setIsOpen] = useState(false);

    const toggleContainer = () => {
        setIsOpen(!isOpen);
    }


    const fixedMatrix = [
        [2, 3, 1, 1],
        [1, 2, 3, 1],
        [1, 1, 2, 3],
        [3, 1, 1, 2],
      ];
    
    let stateTranspose = transposeMatrix(shiftedRows);

    let mixColAnsTrans = transposeMatrix(mixColAns);

      

      function transposeMatrix(matrix) {
        const numRows = matrix.length;
        const numCols = matrix[0].length;
    
        const transposedMatrix = [];
    
        for (let col = 0; col < numCols; col++) {
          transposedMatrix[col] = [];
          for (let row = 0; row < numRows; row++) {
            transposedMatrix[col][row] = matrix[row][col];
          }
        }
    
        return transposedMatrix;
      }

      function binaryToHex(binaryString) {
        const decimalValue = parseInt(binaryString, 2);
        const hexString = decimalValue.toString(16).toUpperCase();
        return hexString;
      }

      

      const icon = {
        hidden: {
          x: -700,
        },
        visible: {
          x: 0,
          transition: {
            delay: 0.25,
            duration: 1,
          },
        },
      };

      let row = fixedMatrix[rowCount]
      let column = stateTranspose[step]

      let array = [row,column]

      //console.log("check:",fixedMatrix[rowCount])
      //console.log("column",stateTranspose[step])
      //console.log("mixColAnsHighlateIndex: ",mixColAnsHighlateIndex)
    return(
        <>
        
        <div className="input-container">
        <div className="flex flex-col items-center">
          <div>
            <h2 className=" font-semibold text-xl">Mixed Columns Multiplication</h2>
          </div>
          <div className="grid grid-flow-col grid-cols-5 align-middle pt-28">
          <div className="col-span-2">
          <div className="grid grid-flow-col grid-cols-3 align-middle pl-5">
            <div>
            <table className=" bg-emerald-100 rounded-xl w-auto">
                <tbody className="">
                
                <tr className={mixColAnsHighlateIndex < 4? "bg-red-300 rounded-xl" : ""}>
                    <td  className="px-4 py-3 whitespace-nowrap">
                    <div className="text-sm text-gray-900 ">{fixedMatrix[0][0]}</div></td>
                    <td  className="px-4 py-3 whitespace-nowrap">
                    <div className="text-sm text-gray-900 ">{fixedMatrix[0][1]}</div></td>
                    <td  className="px-4 py-3 whitespace-nowrap">
                    <div className="text-sm text-gray-900 ">{fixedMatrix[0][2]}</div></td>
                    <td  className="px-4 py-3 whitespace-nowrap">
                    <div className="text-sm text-gray-900 ">{fixedMatrix[0][3]}</div></td>
                </tr>
                <tr className={mixColAnsHighlateIndex < 8  &&  mixColAnsHighlateIndex > 3? "bg-red-300" : ""}>
                    <td  className="px-4 py-3 whitespace-nowrap">
                    <div className="text-sm text-gray-900 ">{fixedMatrix[1][0]}</div></td>
                    <td  className="px-4 py-3 whitespace-nowrap">
                    <div className="text-sm text-gray-900 ">{fixedMatrix[1][1]}</div></td>
                    <td  className="px-4 py-3 whitespace-nowrap">
                    <div className="text-sm text-gray-900 ">{fixedMatrix[1][2]}</div></td>
                    <td  className="px-4 py-3 whitespace-nowrap">
                    <div className="text-sm text-gray-900 ">{fixedMatrix[1][3]}</div></td>
                </tr>
                <tr className={mixColAnsHighlateIndex < 12 &&  mixColAnsHighlateIndex > 7? "bg-red-300" : ""}>
                    <td  className="px-4 py-3 whitespace-nowrap">
                    <div className="text-sm text-gray-900 ">{fixedMatrix[2][0]}</div></td>
                    <td  className="px-4 py-3 whitespace-nowrap">
                    <div className="text-sm text-gray-900 ">{fixedMatrix[2][1]}</div></td>
                    <td  className="px-4 py-3 whitespace-nowrap">
                    <div className="text-sm text-gray-900 ">{fixedMatrix[2][2]}</div></td>
                    <td  className="px-4 py-3 whitespace-nowrap">
                    <div className="text-sm text-gray-900 ">{fixedMatrix[2][3]}</div></td>
                </tr>
                <tr className={mixColAnsHighlateIndex < 16 &&  mixColAnsHighlateIndex > 11? "bg-red-300" : ""}>
                    <td  className="px-4 py-3 whitespace-nowrap">
                    <div className="text-sm text-gray-900 ">{fixedMatrix[3][0]}</div></td>
                    <td  className="px-4 py-3 whitespace-nowrap">
                    <div className="text-sm text-gray-900 ">{fixedMatrix[3][1]}</div></td>
                    <td  className="px-4 py-3 whitespace-nowrap">
                    <div className="text-sm text-gray-900 ">{fixedMatrix[3][2]}</div></td>
                    <td  className="px-4 py-3 whitespace-nowrap">
                    <div className="text-sm text-gray-900 ">{fixedMatrix[3][3]}</div></td>
                </tr>
                </tbody>
                </table>
                </div>

                

                <div className="">
                  <div className=" bg-emerald-100  w-6 ml-16 mt-20">
                      <p>X</p>
                  </div>   
                  <div className="mt-3 mr-9 hover:cursor-pointer">
                    <p onClick={toggleContainer}>How?</p>
                  </div>
                </div>
                

                <div>
                <table className="bg-emerald-100 rounded-xl w-auto">
    <tbody className="">
        <tr>
            <td className={step === 0 ? "px-4 py-3 whitespace-nowrap bg-red-300" : "px-4 py-3 whitespace-nowrap"}>
                <div className="text-sm text-gray-900">{shiftedRows[0][0]}</div>
            </td>
            <td className={step === 1 ? "px-4 py-3 whitespace-nowrap bg-red-300" : "px-4 py-3 whitespace-nowrap"}>
                <div className="text-sm text-gray-900">{shiftedRows[0][1]}</div>
            </td>
            <td className={step === 2 ? "px-4 py-3 whitespace-nowrap bg-red-300" : "px-4 py-3 whitespace-nowrap"}>
                <div className="text-sm text-gray-900">{shiftedRows[0][2]}</div>
            </td>
            <td className={step === 3 ? "px-4 py-3 whitespace-nowrap bg-red-300" : "px-4 py-3 whitespace-nowrap"}>
                <div className="text-sm text-gray-900">{shiftedRows[0][3]}</div>
            </td>
        </tr>
        <tr>
            <td className={step === 0 ? "px-4 py-3 whitespace-nowrap bg-red-300" : "px-4 py-3 whitespace-nowrap"}>
                <div className="text-sm text-gray-900">{shiftedRows[1][0]}</div>
            </td>
            <td className={step === 1 ? "px-4 py-3 whitespace-nowrap bg-red-300" : "px-4 py-3 whitespace-nowrap"}>
                <div className="text-sm text-gray-900">{shiftedRows[1][1]}</div>
            </td>
            <td className={step === 2 ? "px-4 py-3 whitespace-nowrap bg-red-300" : "px-4 py-3 whitespace-nowrap"}>
                <div className="text-sm text-gray-900">{shiftedRows[1][2]}</div>
            </td>
            <td className={step === 3 ? "px-4 py-3 whitespace-nowrap bg-red-300" : "px-4 py-3 whitespace-nowrap"}>
                <div className="text-sm text-gray-900">{shiftedRows[1][3]}</div>
            </td>
        </tr>
        <tr>
            <td className={step === 0 ? "px-4 py-3 whitespace-nowrap bg-red-300" : "px-4 py-3 whitespace-nowrap"}>
                <div className="text-sm text-gray-900">{shiftedRows[2][0]}</div>
            </td>
            <td className={step === 1 ? "px-4 py-3 whitespace-nowrap bg-red-300" : "px-4 py-3 whitespace-nowrap"}>
                <div className="text-sm text-gray-900">{shiftedRows[2][1]}</div>
            </td>
            <td className={step === 2 ? "px-4 py-3 whitespace-nowrap bg-red-300" : "px-4 py-3 whitespace-nowrap"}>
                <div className="text-sm text-gray-900">{shiftedRows[2][2]}</div>
            </td>
            <td className={step === 3 ? "px-4 py-3 whitespace-nowrap bg-red-300" : "px-4 py-3 whitespace-nowrap"}>
                <div className="text-sm text-gray-900">{shiftedRows[2][3]}</div>
            </td>
        </tr>
        <tr>
            <td className={step === 0 ? "px-4 py-3 whitespace-nowrap bg-red-300" : "px-4 py-3 whitespace-nowrap"}>
                <div className="text-sm text-gray-900">{shiftedRows[3][0]}</div>
            </td>
            <td className={step === 1 ? "px-4 py-3 whitespace-nowrap bg-red-300" : "px-4 py-3 whitespace-nowrap"}>
                <div className="text-sm text-gray-900">{shiftedRows[3][1]}</div>
            </td>
            <td className={step === 2 ? "px-4 py-3 whitespace-nowrap bg-red-300" : "px-4 py-3 whitespace-nowrap"}>
                <div className="text-sm text-gray-900">{shiftedRows[3][2]}</div>
            </td>
            <td className={step === 3 ? "px-4 py-3 whitespace-nowrap bg-red-300" : "px-4 py-3 whitespace-nowrap"}>
                <div className="text-sm text-gray-900">{shiftedRows[3][3]}</div>
            </td>
        </tr>
    </tbody>
</table>

                </div>
                </div>
            </div>
          
            

            <div className=" pt-20 pl-7">
            
            <svg
                  width="170"
                  height="38"
                  viewBox="0 0 573 38"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <motion.path
                    variants={icon}
                    initial="hidden"
                    animate="visible"
                    d="M571.771 20.7678C572.748 19.7915 572.748 18.2085 571.771 17.2322L555.861 1.32233C554.885 0.34602 553.302 0.34602 552.326 1.32233C551.349 2.29864 551.349 3.88155 552.326 4.85786L566.468 19L552.326 33.1421C551.349 34.1184 551.349 35.7014 552.326 36.6777C553.302 37.654 554.885 37.654 555.861 36.6777L571.771 20.7678ZM0 21.5H570.003V16.5H0V21.5Z"
                    fill="black"
                  />
                </svg>
            </div>

              <div>
              <table className="bg-emerald-100 rounded-xl w-auto">
    <tbody className="">
        <tr>
            <td className={mixColAnsHighlateIndex === 0 ? "px-5 py-3 whitespace-nowrap bg-red-300" : "px-5 py-3 whitespace-nowrap"}>
                <div className="text-sm text-gray-900">{mixColAns[0][0]}</div>
            </td>
            <td className={mixColAnsHighlateIndex === 4 ? "px-5 py-3 whitespace-nowrap bg-red-300" : "px-5 py-3 whitespace-nowrap"}>
                <div className="text-sm text-gray-900">{mixColAns[0][1]}</div>
            </td>
            <td className={mixColAnsHighlateIndex === 8 ? "px-5 py-3 whitespace-nowrap bg-red-300" : "px-5 py-3 whitespace-nowrap"}>
                <div className="text-sm text-gray-900">{mixColAns[0][2]}</div>
            </td>
            <td className={mixColAnsHighlateIndex === 12 ? "px-5 py-3 whitespace-nowrap bg-red-300" : "px-5 py-3 whitespace-nowrap"}>
                <div className="text-sm text-gray-900">{mixColAns[0][3]}</div>
            </td>
        </tr>
        <tr>
            <td className={mixColAnsHighlateIndex === 1 ? "px-5 py-3 whitespace-nowrap bg-red-300" : "px-5 py-3 whitespace-nowrap"}>
                <div className="text-sm text-gray-900">{mixColAns[1][0]}</div>
            </td>
            <td className={mixColAnsHighlateIndex === 5 ? "px-5 py-3 whitespace-nowrap bg-red-300" : "px-5 py-3 whitespace-nowrap"}>
                <div className="text-sm text-gray-900">{mixColAns[1][1]}</div>
            </td>
            <td className={mixColAnsHighlateIndex === 9 ? "px-5 py-3 whitespace-nowrap bg-red-300" : "px-5 py-3 whitespace-nowrap"}>
                <div className="text-sm text-gray-900">{mixColAns[1][2]}</div>
            </td>
            <td className={mixColAnsHighlateIndex === 13 ? "px-5 py-3 whitespace-nowrap bg-red-300" : "px-5 py-3 whitespace-nowrap"}>
                <div className="text-sm text-gray-900">{mixColAns[1][3]}</div>
            </td>
        </tr>
        <tr>
            <td className={mixColAnsHighlateIndex === 2 ? "px-5 py-3 whitespace-nowrap bg-red-300" : "px-5 py-3 whitespace-nowrap"}>
                <div className="text-sm text-gray-900">{mixColAns[2][0]}</div>
            </td>
            <td className={mixColAnsHighlateIndex === 6 ? "px-5 py-3 whitespace-nowrap bg-red-300" : "px-5 py-3 whitespace-nowrap"}>
                <div className="text-sm text-gray-900">{mixColAns[2][1]}</div>
            </td>
            <td className={mixColAnsHighlateIndex === 10 ? "px-5 py-3 whitespace-nowrap bg-red-300" : "px-5 py-3 whitespace-nowrap"}>
                <div className="text-sm text-gray-900">{mixColAns[2][2]}</div>
            </td>
            <td className={mixColAnsHighlateIndex === 14 ? "px-5 py-3 whitespace-nowrap bg-red-300" : "px-5 py-3 whitespace-nowrap"}>
                <div className="text-sm text-gray-900">{mixColAns[2][3]}</div>
            </td>
        </tr>
        <tr>
            <td className={mixColAnsHighlateIndex === 3 ? "px-5 py-3 whitespace-nowrap bg-red-300" : "px-5 py-3 whitespace-nowrap"}>
                <div className="text-sm text-gray-900">{mixColAns[3][0]}</div>
            </td>
            <td className={mixColAnsHighlateIndex === 7 ? "px-5 py-3 whitespace-nowrap bg-red-300" : "px-5 py-3 whitespace-nowrap"}>
                <div className="text-sm text-gray-900">{mixColAns[3][1]}</div>
            </td>
            <td className={mixColAnsHighlateIndex === 11 ? "px-5 py-3 whitespace-nowrap bg-red-300" : "px-5 py-3 whitespace-nowrap"}>
                <div className="text-sm text-gray-900">{mixColAns[3][2]}</div>
            </td>
            <td className={mixColAnsHighlateIndex === 15 ? "px-5 py-3 whitespace-nowrap bg-red-300" : "px-5 py-3 whitespace-nowrap"}>
                <div className="text-sm text-gray-900">{mixColAns[3][3]}</div>
            </td>
        </tr>
    </tbody>
</table>

              </div>

              <div>
                <div className="grid grid-cols-4 border-solid border-black border-2 p-1 m-1 w-fit rounded-md bg-amber-200 justify-center items-center">
                    <div className="border-solid border-black border-2 m-1 pb-7 text-center justify-center items-center h-6 w-8 text-white bg-gray-500 rounded-md cursor-pointer"
                    onClick={decrementStep}>
                        <p> - </p>
                    </div>

                    <div><p>Step:</p></div>

                    <div   className=" border-solid border-black border-2 m-1 h-6 bg-white text-center justify-center items-center">
                        <p> {step + 1} </p>
                    </div>

                    <div className={`border-solid border-black border-2 pb-7 m-1 ml-5 text-center justify-center items-center h-6 w-7 text-white bg-gray-500 rounded-md cursor-pointer`}
                    onClick={incrementStep}>
                        <p> + </p>
                    </div>
                </div>
                
            </div>
            <div>
                {isOpen && (
            <div className="toggle-container">
                <div><MultiplicationView row={row} column={column} /></div>
            </div>
            )}
            </div>
            </div>
                
            </div>  

            
            
        </div>
        
        
        <div className="button-holder">
            <div className="prev-button" onClick={previous}>
              PREVIOUS
            </div>
          </div>
        </>
    );

}

export default MixColumnsView